import React from 'react';
import { SelectField } from 'is24-corecss';
import { useTranslation } from 'react-i18next';

export const companyFormOptionKeys = [
  'unspecified',
  'unregisteredCompany',
  'registeredMerchant',
  'kg',
  'gmbhAndCoKg',
  'ohg',
  'egbr',
  'ag',
  'se',
  'gmbh',
  'ggmbh',
  'ug',
  'partg',
  'partgMbb',
  'publicLawInstitution',
  'publicLawCorporation',
  'registeredCooperative',
  'registeredAssociation',
  'foundation',
  'other',
] as const;

export type CompanyFormOptionKey = (typeof companyFormOptionKeys)[number];

export const defaultCompanyFormOption: CompanyFormOptionKey = companyFormOptionKeys[0];

interface CompanyFormSelectProps {
  value: CompanyFormOptionKey;
  onChange: (value: CompanyFormOptionKey) => void;
}

const CompanyFormSelect: React.FC<CompanyFormSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SelectField
      id='company-form'
      label={t('KybLandingPage.companyFormLabel1')}
      value={value}
      onChange={(event) => onChange(event.target.value as CompanyFormOptionKey)}
    >
      {companyFormOptionKeys.map((option) => (
        <option key={option} value={option}>
          {t(`CompanyFormSelect.options.${option}`)}
        </option>
      ))}
    </SelectField>
  );
};

export default CompanyFormSelect;
